import React from 'react';
import './ProcessingModal.css';

export type ProcessingKind = 'card' | 'marcial_card' | 'gift_card' | 'return' | 'sale';

interface ProcessingModalProps {
  /** null = oculto. */
  kind: ProcessingKind | null;
}

const COPY: Record<ProcessingKind, { title: string; description: string }> = {
  card: {
    title: 'Procesando Pago',
    description: 'Por favor, acerque o introduzca su tarjeta de crédito o débito en el terminal de cobro...'
  },
  marcial_card: {
    title: 'Procesando Tarjeta Marcial Pons',
    description: 'Verificando validez de la tarjeta parcial Pons y registrando saldo de cobro...'
  },
  gift_card: {
    title: 'Procesando Tarjeta o Cheque Regalo',
    description: 'Procesando cobro en tarjeta regalo o cheque regalo y registrando en caja...'
  },
  return: {
    title: 'Procesando Devolución',
    description: 'Comprobando estado del inventario y registrando abono en caja...'
  },
  sale: {
    title: 'Registrando Venta',
    description: 'Emitiendo la factura en marcialpons y registrando el cobro en caja...'
  }
};

export function ProcessingModal({ kind }: ProcessingModalProps) {
  if (!kind) return null;

  const { title, description } = COPY[kind];

  return (
    <div className="processing-modal-overlay">
      <div className="processing-modal-content">

        {/* Animated Book — page-flip in pure CSS */}
        <div className="processing-book-scene">
          <div className="processing-book-wrapper">

            {/* Left static page */}
            <div className="processing-book-page-left">
              <div className="processing-page-lines">
                <div className="processing-page-line" style={{ width: '100%' }} />
                <div className="processing-page-line" style={{ width: '80%' }} />
                <div className="processing-page-line" style={{ width: '91.67%' }} />
                <div className="processing-page-line" style={{ width: '75%' }} />
                <div className="processing-page-line" style={{ width: '83.33%' }} />
              </div>
            </div>

            {/* Right static page */}
            <div className="processing-book-page-right">
              <div className="processing-page-lines processing-page-lines--right">
                <div className="processing-page-line" style={{ width: '100%' }} />
                <div className="processing-page-line" style={{ width: '91.67%' }} />
                <div className="processing-page-line" style={{ width: '80%' }} />
                <div className="processing-page-line" style={{ width: '83.33%' }} />
                <div className="processing-page-line" style={{ width: '66.67%' }} />
              </div>
            </div>

            {/* Book spine */}
            <div className="processing-book-spine" />

            {/* Primary flipping page */}
            <div className="processing-flip-page" style={{ zIndex: 20 }}>
              {/* Front face */}
              <div className="processing-flip-face processing-flip-face--front">
                <div className="processing-flip-lines">
                  <div className="processing-flip-line processing-flip-line--orange-25" style={{ width: '100%' }} />
                  <div className="processing-flip-line processing-flip-line--orange-25" style={{ width: '91.67%' }} />
                  <div className="processing-flip-line processing-flip-line--orange-20" style={{ width: '83.33%' }} />
                  <div className="processing-flip-line processing-flip-line--orange-20" style={{ width: '80%' }} />
                  <span className="processing-flip-badge">MP</span>
                </div>
              </div>
              {/* Back face */}
              <div className="processing-flip-face processing-flip-face--back">
                <div className="processing-flip-lines">
                  <div className="processing-flip-line processing-flip-line--green-25" style={{ width: '100%' }} />
                  <div className="processing-flip-line processing-flip-line--green-25" style={{ width: '83.33%' }} />
                  <div className="processing-flip-line processing-flip-line--green-20" style={{ width: '91.67%' }} />
                  <div className="processing-flip-line processing-flip-line--green-20" style={{ width: '66.67%' }} />
                  <span className="processing-flip-badge processing-flip-badge--green">MP</span>
                </div>
              </div>
            </div>

            {/* Staggered second flipping page (paper thickness feel) */}
            <div className="processing-flip-page processing-flip-page--stagger" style={{ zIndex: 10 }}>
              {/* Front face */}
              <div className="processing-flip-face processing-flip-face--front-stagger">
                <div className="processing-flip-lines processing-flip-lines--opacity70">
                  <div className="processing-flip-line processing-flip-line--orange-20" style={{ width: '100%' }} />
                  <div className="processing-flip-line processing-flip-line--orange-20" style={{ width: '83.33%' }} />
                  <div className="processing-flip-line processing-flip-line--orange-20" style={{ width: '80%' }} />
                  <div className="processing-flip-line processing-flip-line--orange-15" style={{ width: '91.67%' }} />
                </div>
              </div>
              {/* Back face */}
              <div className="processing-flip-face processing-flip-face--back-stagger">
                <div className="processing-flip-lines processing-flip-lines--opacity70">
                  <div className="processing-flip-line processing-flip-line--green-20" style={{ width: '100%' }} />
                  <div className="processing-flip-line processing-flip-line--green-20" style={{ width: '91.67%' }} />
                  <div className="processing-flip-line processing-flip-line--green-20" style={{ width: '83.33%' }} />
                  <div className="processing-flip-line processing-flip-line--green-15" style={{ width: '75%' }} />
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Title & description */}
        <h3 className="processing-modal-title">{title}</h3>
        <p className="processing-modal-description">{description}</p>

        {/* Bouncing dots */}
        <div className="processing-dots">
          <span className="processing-dot processing-dot--orange" />
          <span className="processing-dot processing-dot--green" />
          <span className="processing-dot processing-dot--dark" />
        </div>

      </div>
    </div>
  );
}
